var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('FormLabel',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }